import {BaseService} from "./BaseService";
import {SnackBarModule} from "../modules/SnackBarModule";


export const ComparativoService = {
    async findOne(matricula) {
        return await BaseService.fetchResponseFromAPIGet("monitor/compare/"+matricula);
    },
    async compareCsv() {
        return await BaseService.fetchResponseFromAPIGet("monitor/compare");
    },
    async getTableData() {
        const response = await BaseService.fetchResponseFromAPIGet("monitor");

        if(response.error) {
            SnackBarModule("Não foi possível buscar a lista de comparativo", "error");
        }

        return response;
    },
    async getTableCount() {
        return await BaseService.fetchResponseFromAPIGet("monitor/groupby");

    },
    async clearAllData() {
        const response = await BaseService.fetchResponseFromAPIGet("monitor/destroy");

        if(response.error) {
            SnackBarModule("Não foi possível apagar a lista de comparativo", "error");
        }

        return response;
    },

    async list_all_ferias() {
      const response = await BaseService.fetchResponseFromAPIGet('monitor/listar');
      return response;
    },

    async submit_csv(data) {

        const response = await BaseService.fetchResponseFromAPIPost('ferias/csv_comparativo',data);
        return response;
    }

}